module.exports = __webpack_public_path__ + "static/media/FindMyWayDowntoYou_Bookcover.6c7472b3.jpg";